import _ from 'lodash';
import BaseAccountController from '../../lib/controllers/BaseAccountController';

export default class LocationAccessController extends BaseAccountController {
	public static $inject: string[] = ['$scope', 'Profile'];
	public nearByClubs: any;
	public otherClubs: any;
	public countries: any;
	public dataLoaded: boolean;

	constructor($scope: ng.IScope, Profile: lt.IProfile) {
		super($scope, Profile);
		this.countries = [];
		this.nearByClubs = {};
		this.dataLoaded = false;
	}

	public sortOtherClubs(): void {
		this.countries = [];
		this.otherClubs = _.groupBy(this.otherClubs, 'country');

		_.forEach(this.otherClubs, (states: any, country: any) => {
			const c: any = {};

			c.country = country;
			c.states = [];

			_.forEach(_.groupBy(states, 'state'), (clubs: any, state: any) => {
				const s: any = {};
				s.state = state;
				s.stateAbbr = clubs[0].stateAbbr;

				s.availableClubs = [];
				s.excludedClubs = [];

				_.forEach(clubs, (club: any) => {
					if ( this.profile.memberDetails!.availableClubs.indexOf(club.mmsClubId) >= 0 ) {
						s.availableClubs.push(club);
					} else {
						s.excludedClubs.push(club);
					}
				});

				c.states.push(s);

			});
			this.countries.push(c);
		});
	}

	/**
	 * Triggered whenever SSO ID is available/changed
	 */
	protected loadData(): void {
		return;
	}

	protected profileDataLoaded(): void {
		let basePath: string;
		if (window.location.hostname === 'localhost') {
			basePath = 'https://qa-my.lifetime.life';
		} else {
			basePath = '';
		}

		this.dataLoaded = false;

		$.ajax({
			dataType: 'json',
			type: 'GET',
			url: basePath + '/bin/lt/nearestClubServlet?cId=' + this.profile.memberDetails!.homeClubId + '&limit=1000&distance=3600',
			success: (data: any) => {
				this.$scope.$apply(() => {
					const radius: number = data[0].salesRadius > 0 ? data[0].salesRadius : 20;

					// remove non-clubs from list
					this.otherClubs = _.filter(data,  (o: any) =>  {
						return o.clubTypeId === 1 || o.clubTypeId === 2;
					});

					this.otherClubs = _.orderBy(this.otherClubs, ['country', 'state', 'name'], ['desc', 'asc', 'asc']);

					// remove near clubs into seperate data groups
					const clubsCopy: any = _.clone(this.otherClubs);
					this.nearByClubs.included = _.remove(clubsCopy, (o: any) => {
						return o.distance <= radius;
					});
					this.nearByClubs.excluded = _.remove(this.nearByClubs.included, (o: any) => {
						return this.profile.memberDetails!.availableClubs.indexOf(o.mmsClubId) < 0;
					});
					this.sortOtherClubs();
					this.dataLoaded = true;
				});
			},
			error: (err: JQueryXHR) => {
				// tslint:disable-next-line: no-console
				console.log('error: ' + err);
			}
		});
	}
}
